import { render, staticRenderFns } from "./TriggerProductsTable.vue?vue&type=template&id=5264de51&scoped=true"
import script from "./TriggerProductsTable.vue?vue&type=script&lang=js"
export * from "./TriggerProductsTable.vue?vue&type=script&lang=js"
import style0 from "./TriggerProductsTable.vue?vue&type=style&index=0&id=5264de51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264de51",
  null
  
)

export default component.exports